import { render, staticRenderFns } from "./BaseBreakouts.vue?vue&type=template&id=315dcc8e&scoped=true&lang=pug"
import script from "./BaseBreakouts.vue?vue&type=script&lang=ts"
export * from "./BaseBreakouts.vue?vue&type=script&lang=ts"
import style0 from "./BaseBreakouts.vue?vue&type=style&index=0&id=315dcc8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315dcc8e",
  null
  
)

export default component.exports